/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import Box from '@mui/material/Box'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Button from '@mui/material/Button'
import React, { useState, useEffect } from 'react'
import {  useNavigate } from 'react-router-dom'
import Axios from 'axios'
// import { useParams } from 'react-router-dom'
import { toast} from 'react-toastify'
import { CheckAuthToken } from '../components/functions/redirectToLogin'

function PageSelectSchools() {
  const [expanded, setExpanded] = React.useState(false)
  const navigate = useNavigate()
  const user = localStorage.getItem('user')
  const token = JSON.parse(localStorage.getItem('token'))
  const [sendaccessrightsids, setSendAccessRightsIds] = useState([])
  const [schoolss, setSchoolss] = useState([])
  const accessrightsid = useState(JSON.parse(user)[0].PersId)
  const acc_id = accessrightsid[0].substring(0, 10)
  var delayInMilliseconds = 3000

  const academy = [...new Set(sendaccessrightsids.map((item) => item.Academy))]

  const courseName = (academy) => {
    let course = sendaccessrightsids.filter((item) => item.Academy === academy)
    return course
  }

  const courseLabel = (item) => {
    if (!item) return ''
    if (item.CourseId === '141') return 'นายทหารชั้นผู้บังคับฝูง (4 หมวดวิชา)'
    if (item.CourseId === '041') return 'นายทหารชั้นผู้บังคับฝูง (5 หมวดวิชา)'
    return item.CourseName || ''
  }

  useEffect(() => {
    Axios.get(process.env.REACT_APP_API +`/SendAccessRightsId/${acc_id}?token=${token}`)
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : (res.data && res.data.err ? [] : [])
        setSendAccessRightsIds(data)
      })
      .catch((err) => {
        if(err.response.status === 400) {
          toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
          CheckAuthToken(err)
        } else {
          console.log("err: ", err.response.data)
        }
      })
  }, [])

  useEffect(() => {
    Axios.get(process.env.REACT_APP_API + `/schoolss/${acc_id}?token=${token}`)
      .then((res) => {
        setSchoolss(res.data)
      })
      .catch((err) => {
        if(err.response.status === 400) {
          // toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
          CheckAuthToken(err)
        } else {
          console.log("err: ", err.response.data)
        }
      })
  }, [])

  const accessrights = async (a) => {
    var Id = a.AccessRightsId
    localStorage.setItem('Academy', a.Academy)
    localStorage.setItem('CourseName', a.CourseName)
    localStorage.setItem('AccessRights', a.AccessRightsId)
    Axios.get(process.env.REACT_APP_API + `/PageSelectSchools?token=${token}`, {
      id: Id,
    })
    navigate('/PageAccessRights')
  }

  const accessrightss = () => {
    toast.error('สิทธิ์การเข้าถึงถูกระงับการใช้งานกรุณาติดต่อ admin')
  }

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  // console.log(sendaccessrightsids.map((sendaccessrightsid,i) => (
  //   console.log(sendaccessrightsid)
  // )))

  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          marginTop: '50px',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            width: '80vw',
            backgroundColor: '#F2F2F7',
            borderRadius: '10px',
          }}
        >
          <Box sx={{ margin: '20px' }}>
            <Box sx={{ marginTop: '50px' }}>
              <p className="HeadTextRegis">หลักสูตร</p>
            </Box>
            {academy.map((sendaccessrightsid, i) => (
              <Accordion
                expanded={expanded === i}
                key={i}
                onChange={handleChange(i)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  key={i}
                >
                  <Typography sx={{ width: '70vw', flexShrink: 0 }} key={i}>
                    {sendaccessrightsid}
                  </Typography>
                </AccordionSummary>

                <AccordionDetails key={i}>
                  {/* {
             sendaccessrightsid.Approve === 0 ? (<Button variant="outlined" sx={{minWidth: 180  }} disabled onClick={()=>accessrights(sendaccessrightsid)}>{sendaccessrightsid.CourseName}</Button>) : sendaccessrightsid.AcctStatus === "ถูกระงับ" ? (<Button variant="outlined" sx={{minWidth: 180  }}  onClick={()=>accessrightss()}>{sendaccessrightsid.CourseName}</Button>) : (<Button variant="outlined" sx={{minWidth: 180  }} onClick={()=>accessrights(sendaccessrightsid)}>{sendaccessrightsid.CourseName}</Button>)
           }     */}
                  {courseName(sendaccessrightsid).map((item, index) =>
                    // <Button variant="outlined" sx={{minWidth: 180  }} disabled onClick={()=>accessrights(sendaccessrightsid)}> {item.CourseName}</Button>
                    item.Approve === 0 ? (
                      <Button
                        key={item.AccessRightsId || index}
                        variant="outlined"
                        sx={{ minWidth: 180 }}
                        disabled
                        onClick={() => accessrights(item)}
                      >
                        {courseLabel(item)}
                      </Button>
                    ) : item.AcctStatus === 'ถูกระงับ' ? (
                      <Button
                        key={item.AccessRightsId || index}
                        variant="outlined"
                        sx={{ minWidth: 180 }}
                        onClick={() => accessrightss()}
                      >
                        {courseLabel(item)}
                      </Button>
                    ) : (
                      <Button
                        key={item.AccessRightsId || index}
                        variant="outlined"
                        sx={{ minWidth: 180 }}
                        onClick={() => accessrights(item)}
                      >
                        {courseLabel(item)}
                      </Button>
                    ),
                  )}
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </Box>
      </Box>
    </div>
  )
}

export default PageSelectSchools
